import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Divider } from '@adobe/react-spectrum';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';

import TaskDetailsHeader from './TaskDetailsHeader';
import TaskStatus from './TaskStatus';
import Team from './Team';

import { TaskContainer, PageContainer, RightSide, LeftSide } from './styles';

import RecentReviewComments from '../../components/comments/RecentReviewComments';
import TaskContent from './TaskContent';
import FileComponent from '../../components/FileComponent/FileComponent';
import getWfFoldersAndFiles from '../../components/assets/workfrontfileutils';
import getAEMFoldersAndFiles from '../../components/assets/aemfileutils';
import getHeaders from '../../utils/headers';
import { handleRootFolderData } from '../../components/FileComponent/fileHelper';

const TaskDetailsPage = props => {
  const location = useLocation();
  const [state, setState] = useState({ isLoading: true, elements: [] });
  const [rootFolder, setRootFolder] = useState();
  const [childFolder, setChildFolder] = useState('');
  const [taskBreadcrumb, setTaskBreadCrumb] = useState([]);
  const [breadcrumbTooltip, setBreadcrumbTooltip] = useState('');

  const { user, ims, userEmail } = props;
  const taskId = location.pathname.split('/');
  const myTaskID = taskId[2];
  const [isTaskStatusUpdated, setTaskStatusUpdated] = useState(false);

  async function getTaskDetails() {
    setState({ ...state, isLoading: true });
    const fields = [
      'description',
      'assignmentsListString',
      'assignments:*',
      'assignedTo',
      'plannedStartDate',
      'plannedCompletionDate',
      'documents',
      'percentComplete',
      'updates',
      'status',
      'allStatuses',
      'project:team:users:role',
      'project:ID',
      'project:program',
      'project:portfolio',
    ];
    const queryParams = { ID: myTaskID };
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK_SEARCH, queryParams, fields },
    );
    if (actionResponse) {
      setState({ ...state, elements: actionResponse, isLoading: false });
      const [{ project } = {}] = actionResponse || [];
      const workfrontFilesAndFolders = await getWfFoldersAndFiles(
        'PROJ',
        project?.ID,
      );

      const aemFilesAndFolders = await getAEMFoldersAndFiles(
        getHeaders(ims),
        `cats-projects/${project?.ID}`,
      );
      const filterFilesAndFolders = workfrontFilesAndFolders?.filter(
        element =>
          element.parentID === null &&
          element.enteredByID === element.sysUserID,
      );

      handleRootFolderData(
        filterFilesAndFolders,
        aemFilesAndFolders,
        'PROJ',
        project?.ID,
        setRootFolder,
      );
      const temp = [];
      actionResponse.forEach(element => {
        temp.push({
          id: element.project.portfolio.ID,
          label: element.project.portfolio.name,
        });
        temp.push({
          id: element.project.program.ID,
          label: element.project.program.name,
        });
        temp.push({
          id: element.project.ID,
          label: element.project.name,
        });
      });
      setTaskBreadCrumb([...temp]);

      setBreadcrumbTooltip(
        ` ${actionResponse[0].project.portfolio.name} / ${actionResponse[0].project.program.name}/${actionResponse[0].project.name}`,
      );
    }
  }

  const handleSubFolderData = data => {
    setChildFolder(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getTaskDetails();
  }, [user, isTaskStatusUpdated]);

  const { elements } = state;
  const [{ ID, project } = {}] = elements || [];
  const wfObjectCodeAndID = {
    objCode: 'PROJ',
    objID: project?.ID,
  };

  return (
    <div className="taskDetailsBoard">
      {state?.elements ? (
        <PageContainer>
          <LeftSide>
            <TaskContainer key={ID}>
              <TaskDetailsHeader
                task={elements[0]}
                taskBreadCrumb={taskBreadcrumb}
                breadcrumbTooltip={breadcrumbTooltip}
              />
              <TaskContent task={elements[0]} />
              <Divider size="S" />
              <FileComponent
                ims={ims}
                wfObjectCodeAndID={wfObjectCodeAndID}
                assetsFolder={childFolder?.length ? childFolder : rootFolder}
                handleSubFolderData={handleSubFolderData}
                rootFolder={rootFolder}
                isTaskComponent
              />
            </TaskContainer>
          </LeftSide>
          <RightSide>
            <div className="right-area">
              {elements[0]?.assignments?.map(row =>
                row.assignedToID === user ? (
                  <TaskStatus
                    id={ID}
                    status={row.status}
                    assignmentID={row.ID}
                    isTaskStatusUpdated={isTaskStatusUpdated}
                    setTaskStatusUpdated={setTaskStatusUpdated}
                  />
                ) : (
                  ''
                ),
              )}
              <RecentReviewComments taskID={ID} userEmail={userEmail} />
              <Team team={project?.team?.users} />
            </div>
          </RightSide>
        </PageContainer>
      ) : (
        ''
      )}
    </div>
  );
};

TaskDetailsPage.propTypes = {
  user: PropTypes.string,
  ims: PropTypes.string,
  userEmail: PropTypes.string,
};

TaskDetailsPage.defaultProps = {
  user: {},
  ims: {},
  userEmail: {},
};

export default TaskDetailsPage;
